import { jsx as _jsx } from "react/jsx-runtime";
import { StackedVerticalBarChart, TileFooter, TileCard } from '@cmd/ui-components';
import { formatWholeNumber, useGetData } from '@cmd/ui-utilities';
import { useInterstateToken } from '@interstate/components/InterstateThemeProvider';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { dateRangeSelector } from '../../../components/LandingPageHeader/LandingPageHeader';
import { organizationSelector } from '../../../state/orgIdState';
import leadsApi, { LeadsDataSource, LeadsResource } from '../../../utils/apis/leadsApiUtils';
import { EXTERNAL_LEAD_COLOR_TOKEN, INTERNAL_LEAD_COLOR_TOKEN } from '../../../utils/colors';
import { getLeadsByAgeSourceLink, leadsByAgeFormatter } from './leadsByAgeUtils';
import './LeadsByAge.scss';
const tileConfigs = {
    [LeadsDataSource.ICO]: {
        descriptionMessage: (intl) => intl.formatMessage({
            id: 'LEADS_BY_AGE_TILE_DESC_ICO',
            defaultMessage: 'The Age of ICO Leads over the Last 7 Days',
        }),
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_NVISION',
            defaultMessage: 'nVision',
        }),
    },
};
const LeadsByAge = ({ 'data-testid': dataTestId, source, }) => {
    const intl = useIntl();
    const testId = `${dataTestId || 'ids'}-leads-by-age`;
    const getToken = useInterstateToken();
    const leadsByAgeChartColors = {
        Internal: getToken(INTERNAL_LEAD_COLOR_TOKEN) || '',
        External: getToken(EXTERNAL_LEAD_COLOR_TOKEN) || '',
    };
    const { descriptionMessage, sourceMessage, } = tileConfigs[source] || {
        descriptionMessage: () => '',
        sourceMessage: () => '',
    };
    const dateRange = useSelector(dateRangeSelector);
    const orgId = useSelector(organizationSelector);
    // No date range is needed in the params because the endpoint will always return the last 7 days
    const params = {
        ...(orgId !== undefined ? { orgId } : {}),
    };
    const endpoint = `${source}/${LeadsResource.LEADS_BY_AGE}`;
    const { data, isLoading, error, } = useGetData(() => leadsApi[endpoint].get(params), params, (res) => leadsByAgeFormatter(res));
    const { chartData, lastUpdatedUTC, totalLeadCount, } = data || {};
    return (_jsx(TileCard, { title: intl.formatMessage({
            id: 'LEADS_BY_AGE_TILE_TITLE',
            defaultMessage: 'Leads by Age',
        }), description: descriptionMessage(intl), className: "leads-by-age", error: !!error, isLoading: isLoading, noData: !totalLeadCount, "data-testid": testId ? `${testId}-widget-tile` : 'ids-widget-tile', footer: (_jsx(TileFooter, { sourceLabel: sourceMessage(intl), sourceLink: getLeadsByAgeSourceLink(source, dateRange), lastUpdated: new Date(lastUpdatedUTC || ''), "data-testid": testId })), children: _jsx(StackedVerticalBarChart, { chartColors: leadsByAgeChartColors, chartId: `svb-chart-leads-by-age-${source}`, data: chartData || [], showTooltip: true, tooltipCategoryFormatter: (_, subcategory) => subcategory, tooltipValueFormatter: (value) => intl.formatMessage({
                id: 'LEAD_COUNT',
                defaultMessage: '{count} Lead{plural}',
            }, {
                count: formatWholeNumber(value),
                plural: value === 1 ? '' : 's',
            }), xAxisLabel: intl.formatMessage({
                id: 'LEADS_BY_AGE_CHART_X_LABEL',
                defaultMessage: 'Days Old',
            }), yAxisLabel: intl.formatMessage({
                id: 'LEADS_BY_AGE_CHART_Y_LABEL',
                defaultMessage: 'Lead Count',
            }) }) }));
};
export default LeadsByAge;
